

import React, { useEffect, useContext, useState } from 'react';
import { Flex, Row, message, Divider, Modal, Drawer, Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import can from '../../../../components/ability';

const iconStyle = {
    fontSize: 28,
}


function ChooseShow(props) {
    const { data, onClick, choose } = props;
    const {
        img, name
    } = data;
    return (
        <div className={`choose-comp-item ${choose?'choose':''}`} onClick={() => onClick(data)}>
            <div className={`item-iamge ${data.component === 'SearchBar' ? 'wide' : ''}`} style={{backgroundImage: `url(${img})`}} />
            <div className='item-title'>{name}</div>
            {choose?<CheckOutlined className='chose-icon' />: null}
        </div>
    )
}

export default (props) => {
    
    const { onChoose, onClose, visible, componentList = [] } = props;
    const [choose, setChoose] = useState();

    useEffect(() => {
        setChoose(undefined);
    }, [visible]);

    function onClickOne(data) {
        setChoose(data)
    }

    function handleOk() {
        if (!choose) {
            onClose();
            return;
        }
        onChoose(choose)
    }

    
    return (
        <Drawer
            title="选择组件"
            placement="bottom"
            height="85%"
            open={visible}
            onClose={onClose}
            destroyOnClose={true}
            styles={{
                body: {
                    paddingBottom: 'env(safe-area-inset-bottom)'
                }
            }}
            extra={
                <Button type="primary" onClick={handleOk} disabled={!choose}>
                    确定
                </Button>
            }
        >
            <div className='page-editor-choose-comp-content'>
                {componentList.map(i => <ChooseShow key={i.component} data={i} choose={choose?.component === i?.component} onClick={onClickOne} />)}
            </div>
        </Drawer>
    );
};